import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'accounts',
    loadComponent: () => import('../components/accounts/accounts.component').then(m => m.AccountsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('../components/login/login.component').then(m => m.LoginComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'logout',
    loadComponent: () => import('../components/logout/logout.component').then(m => m.LogoutComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'signup',
    loadComponent: () => import('../components/sign-up/sign-up.component').then(m => m.SignUpComponent),
    canActivate: [AuthGuard],
    data: { animationState: 'isLeft' }
  },
  {
    path: 'signup/continue',
    loadComponent: () => import('../components/sign-up-continue/sign-up-continue.component').then(m => m.SignUpContinueComponent),
    canActivate: [AuthGuard],
    data: { animationState: 'isRight' }
  },
  {
    path: 'confirm',
    loadComponent: () => import('../components/confirm-account/confirm-account.component').then(m => m.ConfirmAccountComponent),
    canActivate: [AuthGuard],
    data: { animationState: 'isRight' }
  },
  {
    path: 'account-recovery',
    loadComponent: () => import('../components/account-recovery/account-recovery.component').then(m => m.AccountRecoveryComponent),
    canActivate: [AuthGuard],
    data: { animationState: 'isLeft' }
  },
  {
    path: 'confirm-recovery',
    loadComponent: () => import('../components/confirm-recovery/confirm-recovery.component').then(m => m.ConfirmRecoveryComponent),
    canActivate: [AuthGuard],
    data: { animationState: 'isRight' }
  },
  {
    path: 'resend-code',
    loadComponent: () => import('../components/resend-activation-code/resend-activation-code.component').then(m => m.ResendActivationCodeComponent),
    canActivate: [AuthGuard],
    data: { animationState: null }
  },
  {
    path: 'reset-password',
    loadComponent: () => import('../components/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    canActivate: [AuthGuard],
    data: { animationState: null }
  },
  {
    path: 'update_account',
    loadComponent: () => import('../components/update_account/update_account.component').then(m => m.UpdateAccountComponent),
    canActivate: [AuthGuard],
    data: { animationState: null }
  },
  { path: '', redirectTo: '/accounts', pathMatch: 'full' },
  { path: '**', redirectTo: '/accounts', pathMatch: 'full' }
];

